import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getDivision(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createDivision(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/division" + pathname, body);
}

export async function updateDivision(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/division" + pathname, body);
}

export async function deleteDivision(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/division" + pathname, { data: body });
}
